import { type FormControl } from '@angular/forms';

export const NEW_THEME_DEFAULT_NAME = 'New Theme';

export interface CreateThemeDialogData {
  projectId: string;
  name: string;
  usedNames: string[];
}

export enum CreateThemeDialogStatus {
  Form,
  CreatingAI,
}

export interface CreateThemeDialogResult {
  themeId: string;
}

export interface CreateThemeForm {
  name: FormControl<string>;
  idea: FormControl<string>;
  model: FormControl<string | null>;
}

export interface ThemeReferenceAttachment {
  url: string;
  mime: string;
  filename: string;
}
